import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {GpxProcessService} from "../../services/gpxProcess/gpx-process.service";
import {ToolsService} from "../../services/toolsService/tools.service";
import {ToolType} from "../../../configs/toolsEnum";
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-gpx-modal',
  templateUrl: './gpx-modal.component.html',
  styleUrls: ['./gpx-modal.component.scss'],
  animations: [
    trigger('animateShow', [
      transition(':enter', [
        style({opacity: 0, paddingBottom: '0', height: '0'}),
        animate('300ms ease-out',  style({opacity: 1, paddingBottom: '*', height: '*'}))
      ]),
      transition(':leave', [
        style({opacity: 1, paddingBottom: '*', height: '*'}),
        animate('300ms ease-in', style({opacity: 0, paddingBottom: '0', height: '0'}))
      ])
    ])
  ],
})
export class GpxModalComponent implements OnInit{

  public Yiit = Yiit;
  public isValid:boolean = true;
  public gpxConfig = {};
  public gpxConfigHash;
  public toolsList: any[];

  constructor(private gpx: GpxProcessService, private cd: ChangeDetectorRef, private toolAdapter: ToolsService) {}

  ngOnInit(): void {
    this.toolsList = this.toolAdapter.getToolListByType(ToolType.Polyline);
    this.initListeners();
  }

  private initListeners(){
    this.gpx.configUpdated$.subscribe((config:any)=>{
      if (this.gpxConfigHash != JSON.stringify(config)){
        this.gpxConfig = config;
        this.gpxConfigHash = JSON.stringify(this.gpxConfig);
      }
      this.cd.detectChanges();
    });
  }

  public addDependencyToConfig(id, event){
    this.gpxConfig[id].tool = event.target.value;
  }

  canProcess(){
    for (let i in this.gpxConfig){
      if (!this.gpxConfig.hasOwnProperty(i)){
        continue;
      }
      if (this.gpxConfig[i].hasOwnProperty('tool') && this.gpxConfig[i].tool){
        return true;
      }
    }
    return false;
  }

  closeModal() {
    this.gpx.closeModal();
  }

  public confirmNewConfig(){
    for (let i in this.gpxConfig){
      if (!this.gpxConfig.hasOwnProperty(i)){
        continue;
      }
      if (!this.gpxConfig[i].hasOwnProperty('tool') || !this.gpxConfig[i].tool){
        this.gpxConfig[i].tool = null;
      }
    }
    this.gpxConfigHash = JSON.stringify(this.gpxConfig);
    console.log('gpxConfig 2', this.gpxConfig);
    this.gpx.closeModal();
    this.gpx.processDependedTools(this.gpxConfig);
    this.isValid = true;
  }

}
